import React from 'react';

import { useAuthenticator } from "@aws-amplify/ui-react";

import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { Button } from "primereact/button";

import styles from "./Header.module.css";
import logo from "../../assets/logo.svg";
import { doLogin } from '../../utils/auth';
import { goToGettingStarted } from "../../utils/starting";


/**
 * Main header component, prop determines whether the menu is showing.
 */
export const Header = () => {
    const { authStatus } = useAuthenticator((context) => [context.authStatus]);

    const showBurgerMenu = () => {
        // We normally see: "configuring", then either "unauthenticated" or "authenticated"
        console.log(authStatus);

        return (
            authStatus == "authenticated" ?
                <div className={`${styles.flexChild}`}>
                    <Avatar className="p-overlay-badge" icon="pi pi-user" size="xlarge">
                    <Badge value="0" />
                    </Avatar>
                </div>
            :
                <div className={`${styles.flexChild}`}>
                    <Button className="login-button header-button" onClick={doLogin} aria-label="Login">Login</Button>
                    <Button className="get-started-button header-button" onClick={goToGettingStarted} aria-label="Get started">Get Started for free</Button>
                </div>
        );
    };

    const headerLogo = () => {
        return logo;
    };

    return (
        <header className={`bg-white w-full header ${styles.header}`} data-cy="header">
            <div className={`${styles.flexChild} ${styles.logoContainer}`}>
                <img className={styles.Logo} src={headerLogo()} />
            </div>
            <div className={`${styles.flexChild} ${styles.menuContainer}`}>
            </div>
            {showBurgerMenu()}
        </header>
    );
};